import type { ClientGeoArea } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { Chip, Text } from 'react-native-paper';

const styles = StyleSheet.create({
  container: { gap: 8 },
  chipRow: { flexDirection: 'row', flexWrap: 'wrap', gap: 8 }
});

type Props = {
  areas: Pick<ClientGeoArea, 'id' | 'name'>[];
  countLabel: string;
};

export const GeoAreaChipList: FC<Props> = ({ areas, countLabel }) => (
  <View style={styles.container}>
    <Text variant="titleSmall">{countLabel}</Text>
    {areas.length > 0 && (
      <View style={styles.chipRow}>
        {areas.map((area) => (
          <Chip key={area.id} compact mode="flat">
            {area.name}
          </Chip>
        ))}
      </View>
    )}
  </View>
);
